import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import axios from "axios";
import { msalConfig } from "../authentication/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);
const instance = axios.create({
  baseURL: window.environment.REACT_APP_API_URL,
});

const getTokenAndConfig = async (url) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    throw new Error("No user signed in");
  }

  const scopes =
    url === "/DTE/GetDTEUserInfoDetails"
      ? [window.environment.REACT_APP_DTE_CLIENT_ID]
      : [window.environment.REACT_APP_API_SCOPE, "User.Read"];

  const request = {
    scopes: scopes,
    account: accounts[0],
    forceRefresh: true,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    const token = response.accessToken;

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  } catch (error) {
    console.error("Error getting token and config:", error);

    if (error instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup(request);
        const token = response.accessToken;

        return {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      } catch (popupError) {
        console.error("Error acquiring token with popup:", popupError);
        throw popupError;
      }
    }

    throw error;
  }
};

const withAxios = {
  getWithToken: async (url, payload) => {
    try {
      const config = await getTokenAndConfig(url);
      const apiResponse = await instance.get(url, {
        ...config,
        params: payload,
      });
      return apiResponse.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  postWithToken: async (url, data) => {
    try {
      const config = await getTokenAndConfig(url);
      const apiResponse = await instance.post(url, data, config);
      return apiResponse.data;
    } catch (error) {
      console.error("Error submitting data:", error);
      throw error;
    }
  },
};

export default withAxios;
